export const DE = {
    appDrawerTeaser: "Weitere Anwendungen und Profil",
    menuTeaser: "Menü öffnen",
    openMenu: "Menü aufklappen",
    betaSwitch: (enabled) => enabled ? "BETA-Features aktiviert" : "BETA-Features deaktiviert",
    popupMenu: {
        logout: "Logout",
        profileSettings: "Profil-Einstellungen",
        securitySettings: "Sicherheitseinstellungen",
        feedback: "Feedback",
        imprint: "Impressum",
        privacy: "Datenschutz",
        tac: "AGB",
        releaseNotes: "Neuigkeiten",
    },
    appDrawer: {
        switchApps: "Anwendung wechseln",
        loggedInAs: "Angemeldet als",
        logout: "Logout",
        myAccount: "Mein Konto",
        links: {
            feedback: {
                label: "Feedback",
                url: "mailto:support@21re.de",
                overThisLine: "Bitte schreiben Sie ihr Feedback über dieser Linie",
            },
            imprint: {
                label: "Impressum",
                url: "https://21re.de/impressum?lang=de",
            },
            privacy: {
                label: "Datenschutz",
                url: "https://21re.de/datenschutz?lang=de",
            },
            tac: {
                label: "AGB",
                url: "https://21re.de/agb?lang=de",
            },
        },
    },
    apps: {
        admin: {
            title: "Verwaltung",
            submenus: {
                companyDefaults: "Firmen Defaults",
                calculationMethods: "Berechnungsmethoden",
                companySettings: "Firmeneinstellungen",
                apiAdmin: "API Tokens verwalten",
                companyUsers: "Benutzerverwaltung",
                products: "Produktnutzung",
            },
        },
        buy: {
            title: "Kaufen",
            submenus: {
                contactManager: "Kontakte",
                recordedOffers: "Erfasste Angebote",
                workspace: "Deals",
                monitors: "Externe Monitore",
            },
        },
        "???": {
            title: "???",
            submenus: {
                "???": "???",
            },
        },
        phantomMenu: {
            title: "Phantom Menu",
            submenus: {
                content: "Content",
                content1: "Content1",
                content2: "Content2",
                content3: "Content3",
                content4: "Content4",
                content5: "Content5",
                content6: "Content6",
                content7: "Content7",
            },
        },
        account: {
            title: "Mein Konto",
            submenus: {
                profile: "Profil",
                security: "Sicherheit",
            },
        },
        portfolioAnalyse: {
            title: "Portfolio Analyse",
            submenus: {
                inProgress: "In Arbeit",
                calculationMethod: "Berechnungsmethode",
            },
        },
        helion: {
            title: "Helion",
            submenus: {
                home: "Übersicht",
                inProgress: "In Arbeit",
                archive: "Archive",
                notifications: "Benachrichtigungen",
                tasks: "Aufgaben",
                calculations: "Berechnungen",
                settings: "Einstellungen",
            },
        },
        valuation: {
            title: "Bewertung",
            submenus: {
                home: "Übersicht",
            },
        },
        locationAnalytics: {
            title: "RELAS",
            submenus: {
                quickstart: "Quickstart",
                profileManager: "Profile Manager",
                locationAssessment: {
                    name: "Location Assessment",
                    modules: {
                        dashboard: "Dashboard",
                        assessment: "Scores, Ratings, Preise",
                        comparables: "Comparables",
                        marketdata: "Quartiersdaten",
                        poiExplorer: "POI Explorer",
                        specialMaps: "Sonderkarten",
                        rentindex: "Mietspiegel",
                    },
                },
                locationExplorer: "Location Explorer",
                privateData: "Private Data",
                locationSelector: "Location Selector",
                ratingManager: "Rating Manager",
            },
        },
    },
    buy: {
        buy: "Kaufen",
        offerList: "Erfasste Angebote",
        portfolioAnalysis: "Portfolioanalyse",
        offer: "Angebot erfassen",
        archive: "Archiv",
        offerInProgress: "Workspace",
        workflow: "Meine Aufgaben",
        requests: "Gesuch publizieren",
        monitor: "Käufermonitor",
    },
    admin: {
        admin: "Verwaltung",
        companyDefaults: "Firmen Defaults",
        calculationMethods: "Berechnungsmethoden",
        apiTokens: "API token verwalten",
        productUsage: "Produktnutzung",
        companyMembers: "Benutzerverwaltung",
        companySettings: "Firmeneinstellungen",
        autoassign: "Zuweisungs-App",
    },
    sidebar: {
        settings: "Einstellungen",
        monitors: "Externe Monitore",
        notifications: "Benachrichtigungen",
        logout: "Logout",
        feedback: "Feedback",
    },
    forum: "Forum",
    login: "Login",
    registration: "Registrierung",
    profile: {
        logout: "Abmelden",
        language: "Sprache",
        templates: "Vorlagen",
        settings: "Einstellungen",
        monitor: "Externe Monitore",
        statusAndInvoice: "Status & Rechnungen",
        deleteAccount: "Account löschen",
    },
    imprint: "Impressum",
    terms: "AGB",
    privacy: "Datenschutz",
    relativeImprintLink: "impressum?lang=de",
    relativePrivacyLink: "datenschutz?lang=de",
    relativeTermsLink: "agb?lang=de",
    wrongBrowser: "Diese Seite ist optimiert für: ",
    sessionExpired: {
        title: "Ihre Session ist abgelaufen!",
        paragraph: 'Klicken Sie auf "Login im neuen Tab öffnen" um Ihre Session zu erneuern. Nach erfolgreichem Login kehren Sie automatisch auf diese Seite zurück.',
        goToLogin: "Login im neuen Tab öffnen",
    },
};
//# sourceMappingURL=de.js.map